<template>
  <div class="ordersucceed1">
    <div class="pop" v-if="lodingshow"> <van-loading type="spinner" /></div>
    <top-nav1 ref="TopNav1"></top-nav1>
    <van-nav-bar style="background: #F1F1F1"  title="订单提交成功" fixed left-arrow @click-left="goBack" >
      <van-icon slot="right" @click="onClickRight()" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <img style="margin-top: 66px" src="/static/images/success.png" alt="">
    <div style="padding: 0 15px 0 15px" class="van-content">
      <van-cell-group>
        <van-cell style="padding-bottom: 0" v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <i style="position: relative;top: -2px;font-size: 18px" class="van-icon iconfont icon-unie65c fw " ></i>
            <span style="margin:0 30px 0 10px" class="van-cell-text ft16">{{userInfo.consignee}}</span>
            <span  class="fw ft16">{{ userInfo.phone }}</span>
          </template>
        </van-cell>
        <van-cell style="padding:0 0 0 30px" v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <span style="float: left;color: #7A7A7A" >地址：{{ userInfo.province_str }}{{ userInfo.city_str }}{{ userInfo.county_str }}{{ userInfo.town_str }}{{ userInfo.address }}</span>
          </template>
        </van-cell>
      </van-cell-group>
      <img src="/static/images/eline.png" alt="">
      <van-cell-group>
        <van-cell v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <span style="float: left" class="van-cell-text">订单编号</span><span class="specific" >{{ orderInfo.ordersn }}</span>
          </template>
        </van-cell>
        <van-cell v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <span style="float: left" class="van-cell-text">下单时间</span><span class="specific">{{time(orderInfo.add_time)}}</span>
          </template>
        </van-cell>
        <van-cell v-if="dummy!=2&&dummy!=3">
          <template style="overflow: hidden"  slot="title">
            <!-- <span style="float: left" class="van-cell-text">备注</span>
            <span class="specific">{{orderInfo.remark}}</span> -->
            <span style="float: left" class="van-cell-text fw">备注</span ><span class="specific" style="font-size: .24rem;max-width: 80%;" v-html="orderInfo.remark!=''?orderInfo.remark:'无'"> </span>
          </template>
        </van-cell>
      </van-cell-group>
        <van-button @click="godetail()"  class="theme-bd theme-bg">
          查看订单
        </van-button>
        <van-button @click="outLogin()" style="margin-top:10px;border: 1px solid #FFE5E5;background:#FFE5E5;color: #E4442A" >
          注销
        </van-button>
    </div>
    <!--<footer-nav></footer-nav>-->
  </div>
</template>

<script>
  import FooterNav from '@/components/footernav'
  import TopNav1 from '../../components/topnav1'
  export default {
    name: "ordersucceed",
    components: {
      FooterNav,
      TopNav1
    },

    computed: {

    },
    data () {
      return {
        orderID:this.$route.query.orderId,//订单号
        datas:'',
        products:'',
        userInfo:'',
        orderInfo:'',
        dummy:'',
        lodingshow: true,
        gid:this.$route.query.gid
      }
    },
    methods:{
      time:function (timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s
        if(date.getSeconds()<10){
          s='0'+date.getSeconds()
        }else{
          s = date.getSeconds();
        }
        return Y+M+D+h+m+s;
      },
      godetail:function () {
        this.$router.push({path:'/eorder',query:{id:this.orderID,gid:this.gid}})
      },
      outLogin:function () {
        localStorage.removeItem('ECuser')
        this.$router.push({ name: 'Elogin' ,query:{gid:this.gid}})
      },
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav1.topnavPlay()
      },
      getDatas:function () {
        var isUser=localStorage.getItem("ECuser")
        var mallid=localStorage.getItem("mallid");
        var gid = localStorage.getItem("gid")
        this.$api.get('/active/order/information', {id_active:this.gid,token_user:isUser,id_order:this.orderID}, res => {
          this.dummy = res.data.data.source
          this.products = res.data.data.products;
          this.datas = res.data.data;
          this.userInfo = res.data.data.item;
          this.orderInfo = res.data.data.data;
          this.lodingshow=false
        },err=>{
          this.$toast('服务器繁忙，请稍后再试')
        })
      },
    },
    mounted () {
      this.getDatas()
      $('body').css('background','#fff')
    },
    destroyed: function () {
      $('body').css('background','#EFF3F6')
    },
  }
</script>

<style lang="less" >
  .ordersucceed1{

    img {
      width: 100%;
    }

    .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed .van-nav-bar__title {
      text-align: center;
      font-weight: bold;
    }
    .title{
      background: #fff;
      margin-bottom: 10px;
      .van-icon{
        font-size: .4rem;
        margin-bottom: 10px;
      }
    }
    .van-cell-group{
      padding: 10px 0;
      background: #fff;
      .van-cell{
        padding:8px 0;
      }
      .van-cell-text{
        color: #191919!important;
        font-size: .28rem;
        font-weight: bold;
      }
      .specific{
      color: #9E9E9E;float: right;font-size: .28rem;
      }
    }

    .van-cell:not(:last-child)::after{
      border-bottom-width:0;
    }
    .van-button--normal {
      font-size:  .28rem;width: 100%;
      height: 40px;
      line-height: 40px;
      margin-top: 5px;
      border-radius: 6px;
      background: linear-gradient(left, #EF5033, #FF397A);
      background: -webkit-linear-gradient(left, #EF5033, black)!important;
      background: -o-linear-gradient(left,#EF5033, black)!important;
      background: -moz-linear-gradient(left,#EF5033,black)!important;
      background: -ms-linear-gradient(left,#EF5033,#FF397A)!important;
    }
    .title{
      text-align: center;
      padding: 20px 0;
      font-size: .4rem;
    }
    .title .van-icon{
      vertical-align: middle;
      margin-right: 5px;
    }
    .title span{
      vertical-align: middle;
    }
    .pop{
      background-color: #fff!important;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      .van-loading{
        position: absolute;
        top:50%;
        left: 50%;
        margin: -15px 0 0 -15px;
      }
    }
    .van-nav-bar{
      .van-icon{
        font-size: .4rem!important;
      }
    }
  }
  
.theme-bg,.van-checkbox--checked,.van-swipe__indicator--active{background-color:red!important;color:#ffffff!important}
.theme-col,.van-icon-checked{color: red!important;}
.col-hover:hover{color: red!important;}
.col-on{color: red!important;}
.col-focus:focus{color: red!important;}
.col-checked:checked:before{
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/ordersucceed.vue